import { render } from "./DeviceMenu.vue.js?vue&type=template&id=2367120e!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./DeviceMenu.vue?vue&type=template&id=2367120e"
import script from "./DeviceMenu.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./DeviceMenu.vue?vue&type=script&lang=js"
export * from "./DeviceMenu.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./DeviceMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/SharedWeb/scripts/apps/video-engine/components/video-call/DeviceMenu.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2367120e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2367120e', __exports__)) {
    api.reload('2367120e', __exports__)
  }
  
  module.hot.accept("./DeviceMenu.vue.js?vue&type=template&id=2367120e!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./DeviceMenu.vue?vue&type=template&id=2367120e", () => {
    api.rerender('2367120e', render)
  })

}


export default __exports__